import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import OperatorTypes from '../../../common/redux/actions/types/OperatorTypes';
import PostalOperatorMailboxSelector from '../../../wizard/target-node-mailbox-selector/components/PostalOperatorMailboxSelector';
import AdminPresetOperatorMailboxSidebarContainer from './AdminPresetOperatorMailboxSidebarContainer';
import {
  getArrivalCheckedMailboxes,
  getDepartureCheckedMailboxes,
  getArrivalPostalOperators,
  getDeparturePostalOperators,
  getExpandedArrivalPostalOperators,
  getExpandedDeparturePostalOperatorsMailboxAdmin,
  getSelectedArrivalPostalOperators,
  getSelectedDeparturePostalOperators,
} from '../../../wizard/target-node-mailbox-selector/redux/selectors/PostalOperatorSelectors';
import {
  departureMailboxCheckedActionCreator,
  onDeparturePostalOperatorExpandedMailboxAdmin,
  onDeSelectAllDepartureMailboxes,
  onSelectAllDepartureMailboxes,
  retrieveOutboundPostalOperatorsMailboxRequestActionCreator,
} from '../../../wizard/target-node-mailbox-selector/redux/actions/DeparturePostalOperatorActions';
import {
  arrivalMailboxCheckedActionCreator,
  onArrivalPostalOperatorExpanded,
  onDeSelectAllArrivalMailboxes,
  onSelectAllArrivalMailboxes,
  retrieveInboundPostalOperatorsMailboxRequestActionCreator,
} from '../../../wizard/target-node-mailbox-selector/redux/actions/ArrivalPostalOperatorActions';
import {
  saveGlobalSelectionMailboxRequestActionCreator,
  setTabButtonStatus,
} from '../redux/actions/AdminDashboardActions';
import SaveMailboxSelectionModal from '../../../wizard/target-node-mailbox-selector/components/SaveMailboxSelectionModal';
import { createPresetSelectionsOnSave } from '../../../react-table/helpers/utils';

export class GlobalPresetsOperatorMailboxContainer extends Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
    this.state = {
      showOnlySelectedDeparturePostalOperators: false,
      showOnlySelectedArrivalPostalOperators: false,
      showSaveSelectionModal: false,
      saveSelectionCheckedMailboxes: [],
      saveSelectionSelections: [],
      postalOperatorType: '',
    };
  }

  componentDidMount() {
    const defaultDate = moment();
    this.props.retrieveOutboundPostalOperatorsMailboxRequestActionCreator(
      {
        defaultDirection: 'I',
        startDate: defaultDate,
        endDate: defaultDate,
      },
      'Admin',
      '',
    );

    this.props.retrieveInboundPostalOperatorsMailboxRequestActionCreator(
      {
        defaultDirection: 'I',
        startDate: defaultDate,
        endDate: defaultDate,
      },
      'Admin',
      '',
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.departureCheckedMailboxes !== prevProps.departureCheckedMailboxes && this.props.departureCheckedMailboxes.length !== 0) {
      this.props.setTabButtonStatus(true);
    }
    if (this.props.departureCheckedMailboxes.length === 0 && prevProps.departureCheckedMailboxes.length !== 0) {
      this.setState({
        showOnlySelectedDeparturePostalOperators: false,
      });
    }
  }

  onSelectAllDeparturePostalOperators = () => {
    this.props.onSelectAllDepartureMailboxes(this.props.departurePostalOperatorsNodes);
  };

  onSelectAllArrivalPostalOperators = () => {
    this.props.onSelectAllArrivalMailboxes(this.props.arrivalPostalOperatorsNodes);
  };

  onDeSelectAllDeparturePostalOperators = () => {
    this.setState({
      showOnlySelectedDeparturePostalOperators: false,
    });
    this.props.onDeSelectAllDepartureMailboxes();
  };

  onDeSelectAllArrivalPostalOperators = () => {
    this.setState({
      showOnlySelectedArrivalPostalOperators: false,
    });
    this.props.onDeSelectAllArrivalMailboxes();
  };

  onSelectDeparturePostalOperatorOrMailbox = (selected) => {
    if (selected.length === 0) {
      this.setState({
        showOnlySelectedDeparturePostalOperators: false,
      });
    }
    // eslint-disable-next-line react/prop-types
    this.props.departureMailboxCheckedActionCreator(selected, this.props.report);
  };

  onSelectArrivalPostalOperatorOrMailbox = (selected) => {
    if (selected.length === 0) {
      this.setState({
        showOnlySelectedArrivalPostalOperators: false,
      });
    }
    this.props.arrivalMailboxCheckedActionCreator(selected, this.props.report);
  };

  onExpandDeparturePostalOperator = (expanded) => {
    this.props.onDeparturePostalOperatorExpandedMailboxAdmin(expanded);
  };

  onExpandArrivalPostalOperator = (expanded) => {
    this.props.onArrivalPostalOperatorExpanded(expanded);
  };

  onToggleShowOnlySelectedDeparturePostalOperators = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedDeparturePostalOperators: !this.state.showOnlySelectedDeparturePostalOperators,
    });
  };

  onToggleShowOnlySelectedArrivalPostalOperators = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedArrivalPostalOperators: !this.state.showOnlySelectedArrivalPostalOperators,
    });
  };

  openSaveSelectionModalForDeparture = () => {
    this.openSaveSelectionModal({
      checkedMailboxes: createPresetSelectionsOnSave(this.props.departureCheckedMailboxes, this.props.departurePostalOperatorsNodes),
      selections: this.props.departureSelections,
      postalOperatorType: 'DEPARTURE',
    });
  };

  openSaveSelectionModalForArrival = () => {
    this.openSaveSelectionModal({
      checkedMailboxes: createPresetSelectionsOnSave(this.props.arrivalCheckedMailboxes, this.props.arrivalPostalOperatorsNodes),
      selections: this.props.arrivalSelections,
      postalOperatorType: 'ARRIVAL',
    });
  };

  openSaveSelectionModal = ({ checkedMailboxes, selections, postalOperatorType }) => {
    this.setState({
      showSaveSelectionModal: true,
      saveSelectionCheckedMailboxes: checkedMailboxes,
      saveSelectionSelections: selections,
      postalOperatorType,
    });
  };

  closeSaveSelectionModal = () => {
    this.setState({
      showSaveSelectionModal: false,
    });
  };

  saveSelection = ({ name, checkedMailboxes }) => {
    this.props.saveGlobalSelectionMailboxRequestActionCreator(
      name,
      'I',
      this.state.postalOperatorType,
      checkedMailboxes,
    );
    this.closeSaveSelectionModal();
  };

  render() {
    const departurePostalOperatorSelectorProps = {
      selected: this.props.departureCheckedMailboxes,
      expanded: this.props.departureExpandedPostalOperators,
      expandDisabled: false,
      isShowOnlySelected: this.state.showOnlySelectedDeparturePostalOperators,
      postalOperatorNodes: this.state.showOnlySelectedDeparturePostalOperators ?
        this.props.selectedDeparturePostalOperatorsNodes : this.props.departurePostalOperatorsNodes,
      originalPostalOperatorNodes: this.props.departurePostalOperatorsNodes,
      onSelect: this.onSelectDeparturePostalOperatorOrMailbox,
      onExpand: this.onExpandDeparturePostalOperator,
      onSelectAll: this.onSelectAllDeparturePostalOperators,
      onDeSelectAll: this.onDeSelectAllDeparturePostalOperators,
      onShowOnlySelected: this.onToggleShowOnlySelectedDeparturePostalOperators,
      openSaveSelectionModal: this.openSaveSelectionModalForDeparture,
      saveSelectionButtonHidden: true,
    };

    // eslint-disable-next-line no-unused-vars
    const arrivalPostalOperatorSelectorProps = {
      selected: this.props.arrivalCheckedMailboxes,
      expanded: this.props.arrivalExpandedPostalOperators,
      expandDisabled: false,
      isShowOnlySelected: this.state.showOnlySelectedArrivalPostalOperators,
      postalOperatorNodes: this.state.showOnlySelectedArrivalPostalOperators ?
        this.props.selectedArrivalPostalOperatorsNodes : this.props.arrivalPostalOperatorsNodes,
      originalPostalOperatorNodes: this.props.arrivalPostalOperatorsNodes,
      onSelect: this.onSelectArrivalPostalOperatorOrMailbox,
      onExpand: this.onExpandArrivalPostalOperator,
      onSelectAll: this.onSelectAllArrivalPostalOperators,
      onDeSelectAll: this.onDeSelectAllArrivalPostalOperators,
      onShowOnlySelected: this.onToggleShowOnlySelectedArrivalPostalOperators,
      openSaveSelectionModal: this.openSaveSelectionModalForArrival,
      saveSelectionButtonHidden: true,
    };
    return (
      <div>
        <div className="operator-selector-wrapper">
          {this.state.showSaveSelectionModal &&
          <SaveMailboxSelectionModal
            saveSelection={this.saveSelection}
            closeModal={this.closeSaveSelectionModal}
            checkedMailboxes={this.state.saveSelectionCheckedMailboxes}
            selections={this.state.saveSelectionSelections}
          />
          }
          <div className="operator-sidebar">
            <AdminPresetOperatorMailboxSidebarContainer
              operatorType={OperatorTypes.DEPARTURE}
              operators={this.props.departurePostalOperatorsNodes}
              checked={this.props.departureCheckedMailboxes}
            />
          </div>
          <div className="operators">
            <div className="operators-selection-panel">
              <div className="operator">
                <PostalOperatorMailboxSelector
                  title="OPERATOR/MAILBOX"
                  {...departurePostalOperatorSelectorProps}
                />
              </div>

              {/* <div className="operator">
                <PostalOperatorMailboxSelector
                  title="ARRIVAL OPERATOR"
                  {...arrivalPostalOperatorSelectorProps}
                />
              </div> */}
            </div>
          </div>
          {/* <div className="operator-sidebar">
            <AdminPresetOperatorMailboxSidebarContainer
              operatorType={OperatorTypes.ARRIVAL}
              operators={this.props.arrivalPostalOperatorsNodes}
              checked={this.props.arrivalCheckedMailboxes}
            />
          </div> */}
        </div>
      </div>
    );
  }
}

GlobalPresetsOperatorMailboxContainer.propTypes = {
  retrieveOutboundPostalOperatorsMailboxRequestActionCreator: PropTypes.func,
  retrieveInboundPostalOperatorsMailboxRequestActionCreator: PropTypes.func,
  selectedDeparturePostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  departurePostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  departureCheckedMailboxes: PropTypes.arrayOf(PropTypes.string),
  departureExpandedPostalOperators: PropTypes.arrayOf(PropTypes.string),
  departureSelections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    ediMailboxes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  selectedArrivalPostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  arrivalPostalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  arrivalCheckedMailboxes: PropTypes.arrayOf(PropTypes.string),
  arrivalExpandedPostalOperators: PropTypes.arrayOf(PropTypes.string),
  arrivalSelections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    ediMailboxes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  saveGlobalSelectionMailboxRequestActionCreator: PropTypes.func,
  departureMailboxCheckedActionCreator: PropTypes.func,
  onDeparturePostalOperatorExpandedMailboxAdmin: PropTypes.func,
  onSelectAllDepartureMailboxes: PropTypes.func,
  onDeSelectAllDepartureMailboxes: PropTypes.func,
  arrivalMailboxCheckedActionCreator: PropTypes.func,
  onArrivalPostalOperatorExpanded: PropTypes.func,
  onSelectAllArrivalMailboxes: PropTypes.func,
  onDeSelectAllArrivalMailboxes: PropTypes.func,
  setTabButtonStatus: PropTypes.func,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  retrieveOutboundPostalOperatorsMailboxRequestActionCreator,
  retrieveInboundPostalOperatorsMailboxRequestActionCreator,
  saveGlobalSelectionMailboxRequestActionCreator,
  departureMailboxCheckedActionCreator,
  onDeparturePostalOperatorExpandedMailboxAdmin,
  onSelectAllDepartureMailboxes,
  onDeSelectAllDepartureMailboxes,
  arrivalMailboxCheckedActionCreator,
  onArrivalPostalOperatorExpanded,
  onSelectAllArrivalMailboxes,
  onDeSelectAllArrivalMailboxes,
  setTabButtonStatus,
}, dispatch);

const mapStateToProps = state => ({
  selectedDeparturePostalOperatorsNodes: getSelectedDeparturePostalOperators(state),
  departurePostalOperatorsNodes: getDeparturePostalOperators(state),
  departureCheckedMailboxes: getDepartureCheckedMailboxes(state),
  departureExpandedPostalOperators: getExpandedDeparturePostalOperatorsMailboxAdmin(state),
  selectedArrivalPostalOperatorsNodes: getSelectedArrivalPostalOperators(state),
  arrivalPostalOperatorsNodes: getArrivalPostalOperators(state),
  arrivalCheckedMailboxes: getArrivalCheckedMailboxes(state),
  arrivalExpandedPostalOperators: getExpandedArrivalPostalOperators(state),
});

/* Needed for prop-types with cloneElement */
export const ConnectedGlobalPresetsOperatorMailboxContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(GlobalPresetsOperatorMailboxContainer);

export default (ConnectedGlobalPresetsOperatorMailboxContainer);
